import React, {useEffect, useState} from 'react';
import {Badge, Col, Container, Row} from 'react-bootstrap';
import {FaCheckSquare, FaChevronCircleRight, FaSquare} from 'react-icons/fa';
import {GiCubes} from 'react-icons/gi';
import {Dimensions, FlatList, StyleSheet, View} from 'react-native';
import {ListItem} from 'react-native-elements';
import HomeHeader from '../../components/HomeHeader';

const HEIGHT = Dimensions.get('window').height;
const WIDTH = Dimensions.get('window').width;

function ItemView(props) {
  
  const onPress = () => {
    props.clicked(props.item);
  };

  useEffect(() => {}, []);
  
  const printRates = (rates) => {
    let rateString = '';
    console.log('rates', rates);
    if (rates.length > 0) {
      rates.forEach((rateObj, ind) => {
        const index = ind + 1;
        rateString =
          rateString +
          '\n' +
          index +
          ') ' +
          'Rs.' +
          rateObj.mrpPrice +
          '/-' +
          ' for ' +
          rateObj.months +
          ' month';
      });
    }
    return rateString;
  };
  
  return (
    <ListItem
      onPress={onPress}
      bottomDivider
      containerStyle={{backgroundColor: 'black'}}
      style={{margin: 10}}>
      <GiCubes color="#007bff" size={29} style={{alignSelf: 'flex-start'}} />
      <ListItem.Content>
        <ListItem.Title
          allowFontScaling={true}
          numberOfLines={1}
          style={{color: 'gold', textTransform: 'uppercase'}}>
          {props.item.name}{' '}
          <Badge variant="secondary">{props.item.boxtype_lbl}</Badge>{' '}
          <Badge variant="primary">{props.item.type_lbl}</Badge>
        </ListItem.Title>
        <ListItem.Subtitle style={{color: 'white'}}>
          {props.item.description} {printRates(props.item.rate)}
        </ListItem.Subtitle>
      </ListItem.Content>
      <ListItem.CheckBox
        checkedIcon={<FaCheckSquare color="red" />}
        uncheckedIcon={<FaSquare color="white" />}
        checked={props.selected.includes(props.item.id) ? true : false}
        checkedColor={'red'}
      />
    </ListItem>
  );
}

export default function CheckoutScreen(props) {

  const [products, setProducts] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isChanged, setIsChanged] = useState(false);

  const keyextractor = (item, index) => index.toString();

  const renderer = ({item, index}) => (
    <ItemView
      selected={selected}
      navigation={props.navigation}
      item={item}
      index={index}
      clicked={(i) => {
        if (selected.includes(item.id)) {
          let sl = selected;
          sl.splice(sl.indexOf(item.id), 1);
          setSelected(sl);
        } else {
          let sl = selected;
          sl.push(item.id);
          setSelected(sl);
        }
        setIsChanged((prev) => !prev);
      }}
    />
  );

  const onPlusIconPress = () => {};
  
  return (
    <View>
      <HomeHeader navigation={props.navigation} />
      <Container>
        <Row>
          <Col md={3}></Col>
          <Col md={6}>
            <FlatList
              showsHorizontalScrollIndicator={false}
              pagingEnabled={false}
              data={products}
              extraData={isChanged ? products : products}
              keyExtractor={keyextractor}
              renderItem={renderer}
            />
          </Col>
          <Col md={3}></Col>
        </Row>
      </Container>
      <View style={styles.iconButtonViewStyle}>
        <FaChevronCircleRight
          size={50}
          color="white"
          onClick={onPlusIconPress}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  indicatorStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: HEIGHT,
  },
  iconButtonViewStyle: {
    position: 'absolute',
    bottom: 50,
    right: 50,
  },
});
